import ViocPage from '../../components/ViocPage'

export default ViocPage
